<template>
	<div  class="teambuying flex_c_s">
		<img class="teambuying_img" :src="details.goods_image" mode="aspectFill"></img>
		<div class="teambuying_flex flex1">
			<div class="teambuying_name ellipsis2">{{details.goods_name || ''}}</div>
			<div class="teambuying_times ellipsis" v-if="details.selling_point" style="width: 200px;">{{details.selling_point || ''}}</div>
			<div class="teambuying_data flex_c_s" >
				<div class="teambuying_tag flex1 "  >
					<div class="teambuying_tag_item ellipsis"  >商品标签</div>
				</div>
				<div class="teambuying_flex_storck">已售22</div>
			</div>
			<div class="teambuying_buy flex_c_s">
				<div class="teambuying_buy_left  ">
					<div class="">
						<div class="teambuying_buy_money">
							<!-- <view class="teambuying_buy_text">专享价</view> -->
							<div class="teambuying_buy_type">￥</div>
							<div class="teambuying_buy_num">{{ details.goods_price_min || '' }}</div>
						</div>
						<div class="teambuying_you">
							<div class="teambuying_you_left">专享优惠</div>
							<div class="teambuying_you_right">共省{{ (details.line_price_min-details.goods_price_min).toFixed() }}元</div>
						</div>
						<!-- <view v-if="Number(details.line_price_min)" class="teambuying_buy_zhe">
							{{ discountCalculator(details.line_price_min, details.goods_price_min, 'discount') }}折
						</view>
						<view v-if="Number(details.line_price_min)" class="teambuying_buy_old">
							￥{{ $util.removeTrailingZero(details.line_price_min) || '' }}
						</view> -->
					</div>
					
					<!-- <div class="teambuying_buy_money">
						<div class="teambuying_buy_type">￥</div>
						<div class="teambuying_buy_num">{{details.goods_price_min || 0}}</div>
					</div>
					<div class="teambuying_buy_zhe">4.1折</div>
					<div class="teambuying_buy_old">￥{{details.line_price_min || 0}}</div> -->
				</div>
				<div class="teambuying_buy_but" :style="{background:itemStyle.butbg,color:itemStyle.textcolor}">{{params.text || '抢购'}}</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
	  components: {
	  },
	  props: {
	    // 标签文字
	    details: {
			type:Object
		},
		// 标签文字
		params: {
			type:Object
		},
		itemStyle: {
			type:Object
		},
	  },
	  data () {
	    return {}
	  }
	}
</script>

<style lang="scss" scoped>
	.teambuying{
		padding:10px;
		&_img{
			width: 105px;
			height: 105px;
			display: block;
			margin-right: 9px;
			border-radius: 10px;
		}
		&_flex{
			&_storck{
				color: #666666;
				font-size: 12px;
			}
		}
		&_name{
			height: 32px;
			overflow: hidden;
			color: #02020E;
			font-size: 14px;
			font-weight: bold;
			line-height: 16px;
		}
		&_data{
			
		}
		&_tag{
			padding-top: 6px;
			padding-bottom: 8px;
			&_item{
				border: 1px solid #E8DDE1;
				border-radius: 2px;
				height: 17px;
				line-height: 17px;
				padding: 0 4px;
				display: inline-block;
				margin-right: 4px;
				font-size: 10px;
				color: #B5B7B9;
			}
		}
		&_buy{
			height: 32px;
			overflow: hidden;
			&_left{
				padding-left: 9px;
			}
			&_money{
				display: flex;
				align-items: flex-end;
			}
			&_type{
				color: #F21212;
				font-size: 12px;
				font-weight: bold;
				line-height: 10px;
			}
			&_num{
				color: #F21212;
				font-size: 15px;
				font-weight: bold;
				line-height: 12px;
			}
			&_zhe{
				border: 1px solid #F21212;
				border-radius: 2px;
				padding: 0 6rpx;
				display: inline-block;
				height: 15px;
				line-height: 15px;
				margin-left: 4px;
				color: #F21212;
				font-size: 9px;
			}
			&_old{
				color: #C0C0C3;
				font-size: 11px;
				margin-left: 4px;
			}
			&_but{
				padding: 0 8px;
				font-size: 12px;
				height: 24px;
				line-height: 24px;
				border-radius: 5px 5px;
				
			}
			&_notice{
				white-space: nowrap;
				&_item{
					border: 1px solid #999;
					margin-right: 3px;
					border-radius: 2px;
					display: inline-block;
					font-size: 10px;
					color: #999;
					padding: 1px 3px;
					margin-right: 3px;
				}
			}
			&_times{
				color: #999;
				font-size: 20rpx;
				padding-top: 10rpx;
			}
			
		}
		&_you{
			display: inline-flex;
			align-items: center;
			background: #f212121a;
			margin-top: 5px;
			padding:1px 2px;
			border-radius: 2px;
			&_left{
				font-size: 9px;
				padding: 0 2px;
				color: #f21212;
			}
			&_right{
				font-size: 9px;
				padding: 2rpx 2px;
				color: #f21212;
				background-color: #fff;
				display: inline-block;
				border-radius: 2px;
			}
		}
	}
</style>